export const RESOURCE_TYPES = {
  USERS: "users",
  MEMBER_COMPANIES: "member-companies",
};
